<div class="al-welcome-wrapper pt-68 pl-36 pr-36">
    <mat-horizontal-stepper #stepper class="content-container pt-12 pb-12 pr-20 pl-20" [selectedIndex]="currentStep"
        (selectionChange)="onStepChange($event)">
        <mat-step *ngFor="let alert of alertData;">
            <h2 *ngIf="alert.alert_title != ''" class="text-center font-weight-900 mt-8">{{alert.alert_title}}</h2>
            <div [innerHTML]="alert.alert_message | safeHtml"></div>
        </mat-step>
    </mat-horizontal-stepper>
    <div class="btn-group mt-24" fxLayout="row" fxLayoutAlign="center stretch" fxLayoutGap="30px">
        <button mat-raised-button type="button" class="accent-500 pr-24" *ngIf="currentStep != 0" (click)="goBack()">
            <mat-icon>keyboard_arrow_left</mat-icon> {{"Go Back" | translate}}
        </button>
        <button mat-raised-button type="button" class="accent-500 pl-24"
            *ngIf="currentStep+1 != alertData.length && alertData.length != 1" (click)="goForward()">{{"Next" |
            translate}}
            <mat-icon>keyboard_arrow_right</mat-icon>
        </button>
        <button mat-raised-button type="button" class="accent-500 pl-24 pr-24"
            *ngIf="currentStep+1 == alertData.length || alertData.length == 1"
            (click)="redirectToMemberView()">{{"Member
            Page" | translate}}</button>
    </div>
</div>